import { render, staticRenderFns } from "./iiframe.vue?vue&type=template&id=332f3343"
import script from "./iiframe.vue?vue&type=script&lang=js"
export * from "./iiframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports